export type AllowanceBreakdownLine = {
  id?: string | number;
  name?: string;
  amount?: number;
  type?: string;
};

export function isAllowancePayeTaxable(line: AllowanceBreakdownLine): boolean {
  const type = String(line.type ?? '').toLowerCase();
  return type === 'taxable' || type === 'tax';
}

/** ZRA-exempt allowances (not included in PAYE taxable income). */
export function isAllowanceZraExempt(line: AllowanceBreakdownLine): boolean {
  return !isAllowancePayeTaxable(line);
}

export function getAllowanceBreakdownLines(
  payslip: {
    allowanceBreakdown?: AllowanceBreakdownLine[];
    allowance_breakdown?: AllowanceBreakdownLine[];
  }
): AllowanceBreakdownLine[] {
  return payslip.allowanceBreakdown ?? payslip.allowance_breakdown ?? [];
}

/** Allowances shown on Approvals — ZRA-exempt only. */
export function getZraExemptAllowanceLines(
  payslip: {
    allowanceBreakdown?: AllowanceBreakdownLine[];
    allowance_breakdown?: AllowanceBreakdownLine[];
  }
): AllowanceBreakdownLine[] {
  return getAllowanceBreakdownLines(payslip).filter(
    (line) => line.name && isAllowanceZraExempt(line)
  );
}
